/**
 * Keuzeopties als "één per regel" (FBK-1).
 *
 * Het tekstvak in de formulierbouwer houdt zijn eigen ruwe tekst bij en geeft alleen de geparste
 * opties door. Werd de tekst opnieuw uit de opties opgebouwd, dan viel een Enter (een lege regel)
 * of een spatie aan het einde meteen weg, en kon je geen tweede optie of "Optie A" typen.
 */

export interface OptionLine {
  value: string;
  label: { nl: string };
}

/** Een leesbare sleutel uit een label: "Jaarlijkse vakantie" wordt `jaarlijkse-vakantie`. */
export function slug(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replaceAll(/[̀-ͯ]/g, '')
    .replaceAll(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
}

/** De ruwe tekst naar opties: lege regels weg, spaties rond een regel weg, binnenin blijven ze. */
export function parseOptionLines(text: string): OptionLine[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .map((line) => ({ value: slug(line), label: { nl: line } }));
}
